export const USER_TYPES = [
  "Renter",
  "Landlord",
  "Property Manager",
  "Leasing Agent",
  "Realtor",
  "Housing Professional",
  "Other",
];

export const SENTIMENTS = ["Positive", "Negative", "Mixed"];

export const STATUSES = [
  "New",
  "Reviewed",
  "Follow-up needed",
  "Approved for anonymous use",
  "Do not use",
];

export const STATUS_STYLES = {
  New: "bg-slate-100 text-slate-700 border-slate-300",
  Reviewed: "bg-blue-50 text-blue-700 border-blue-300",
  "Follow-up needed": "bg-amber-50 text-amber-700 border-amber-300",
  "Approved for anonymous use": "bg-green-50 text-green-700 border-green-300",
  "Do not use": "bg-red-50 text-red-700 border-red-300",
};

export const PROPERTY_TYPES = ["Apartment", "Condo", "Single Family", "Townhome", "ADU", "Other"];
export const INCOME_OPTIONS = ["2x", "2.5x", "3x", "3.5x", "4x", "Custom"];
export const COSIGNER_OPTIONS = ["Yes", "No", "Case-by-case"];
export const CRITERIA_STATUSES = ["Pending", "Verified", "Rejected", "Archived"];
export const CRITERIA_STATUS_STYLES = {
  Pending: "bg-amber-50 text-amber-700 border-amber-300",
  Verified: "bg-green-50 text-green-700 border-green-300",
  Rejected: "bg-red-50 text-red-700 border-red-300",
  Archived: "bg-slate-100 text-slate-600 border-slate-300",
};
